/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const propTypes = {
  message: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  sentAt: PropTypes.string.isRequired,
  isClient: PropTypes.bool.isRequired,
};

const ChatMessage = ({ message, name, sentAt, isClient }) => (
  <Container company={!isClient}>
    <Header>
      <Sender>{name}</Sender>
      <span>{sentAt}</span>
    </Header>
    <Message>{message}</Message>
  </Container>
);

ChatMessage.propTypes = propTypes;

const Container = styled.div`
  align-self: ${props => props.company ? 'flex-start' : 'flex-end'};
  background-color: ${
    props => props.company
      ? props.theme['grey-xlight']
      : props.theme['green-normal']
    };
  border-radius: 6px;
  box-sizing: border-box;
  color: ${
    props => props.company
      ? props.theme['text-black']
      : props.theme['text-white']
    };
  margin-bottom: 12px;
  padding: 12px;
  max-width: 90%;
  min-width: 40%;

  &:first-child {
    margin-top: 12px;
  }
`;

const Header = styled.div`
  font-size: 12pt;
  margin-bottom: 6px;
`;

const Message = styled.p`
  margin: 0;
`;

const Sender = styled.span`
  display: inline-block;
  font-weight: bold;
  margin-right: 6px;
`;

export default ChatMessage;
